<template>
  <div class="reader">
    <div class="camera-wrapper" ref="wrapper">
      <video ref="video" autoplay muted playsinline></video>
      <canvas ref="canvas" class="overlay"></canvas>
    </div>
    <div class="feedback">
      <p class="status" :class="statusClass">{{ statusMessage }}</p>
    </div>
    <button @click="capture" :disabled="capturing || !hasFace || processing">
      {{ processing ? 'Processando...' : capturing ? 'Capturando…' : 'Tirar Selfie' }}
    </button>
  </div>
</template>

<script>
import * as faceapi from 'face-api.js'

export default {
  name: 'FacialReader',
  props: {
    onRead: { type: Function, required: true },
    processing: { type: Boolean, default: false }
  },
  data () {
    return {
      stream: null,
      capturing: false,
      statusMessage: '',
      preview: '',
      statusClass: 'info',
      hasFace: false, // só habilita o botão quando tem rosto
      detectionInterval: null
    }
  },
  async mounted () {
    try {
      await faceapi.nets.tinyFaceDetector.loadFromUri('/models')

      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment', width: { ideal: 640 }, height: { ideal: 480 } }
      })
      this.$refs.video.srcObject = this.stream
      this.$refs.video.onloadedmetadata = () => {
        const video = this.$refs.video
        const wrapper = this.$refs.wrapper

        const setAspectRatio = () => {
          if (video.videoWidth && video.videoHeight) {
            wrapper.style.aspectRatio = `${video.videoWidth}/${video.videoHeight}`
            wrapper.style.paddingTop = ''
          }
        }

        setAspectRatio()
        video.onresize = setAspectRatio
        video.onloadeddata = setAspectRatio
        this.startDetection()
      }
    } catch (err) {
      console.error('Erro ao acessar câmera', err)
      alert('Não foi possível acessar a câmera')
    }
  },
  beforeDestroy () {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop())
    }
    if (this.detectionInterval) {
      clearInterval(this.detectionInterval)
    }
  },
  methods: {
    startDetection () {
      const video = this.$refs.video
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')

      this.detectionInterval = setInterval(async () => {
        if (video.readyState < 2) return

        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        try {
          const detection = await faceapi.detectSingleFace(
            video,
            new faceapi.TinyFaceDetectorOptions({
              inputSize: 416,
              scoreThreshold: 0.5
            })
          )

          if (detection) {
            this.hasFace = true
            this.statusMessage = ''

            const resized = faceapi.resizeResults(detection, {
              width: video.videoWidth,
              height: video.videoHeight
            })

            ctx.strokeStyle = '#00ff00'
            ctx.lineWidth = 4
            ctx.strokeRect(
              resized.box.x,
              resized.box.y,
              resized.box.width,
              resized.box.height
            )
          } else {
            this.hasFace = false
            this.statusMessage = 'Posicione o rosto na câmera'
            this.statusClass = 'warning'
          }
        } catch (err) {
          console.error('Erro na detecção', err)
          this.hasFace = false
        }
      }, 500)
    },

    async capture () {
      if (this.capturing || !this.hasFace) return

      this.capturing = true
      this.statusClass = 'info'
      this.statusMessage = 'Capturando...'

      try {
        const video = this.$refs.video
        const detection = await faceapi.detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())

        if (!detection) {
          this.statusMessage = 'Rosto sumiu!'
          this.statusClass = 'warning'
          throw new Error('Rosto sumiu!')
        }

        const resized = faceapi.resizeResults(detection, {
          width: video.videoWidth,
          height: video.videoHeight
        })
        const box = resized.box

        // Margem extra ao redor do rosto
        const margin = 0.9
        const w = box.width * (1 + margin * 2)
        const h = box.height * (1 + margin * 2)
        const x = Math.max(0, box.x - box.width * margin)
        const y = Math.max(0, box.y - box.height * margin)

        const tempCanvas = document.createElement('canvas')
        tempCanvas.width = w
        tempCanvas.height = h
        const ctx = tempCanvas.getContext('2d')
        ctx.drawImage(video, x, y, w, h, 0, 0, w, h)

        const blob = await new Promise(resolve => {
          tempCanvas.toBlob(resolve, 'image/jpeg', 0.99)
        })

        if (!blob) throw new Error('Falha ao gerar imagem')

        const file = new File([blob], `selfie_${Date.now()}.jpg`, { type: 'image/jpeg' })
        this.preview = blob
        this.onRead({ photo: file })
      } catch (err) {
        console.error(err)
        this.statusMessage = err.message || 'Erro na captura'
        this.statusClass = 'error'
      } finally {
        this.capturing = false
        this.statusMessage = ''
      }
    }
  }
}
</script>

<style scoped>
.reader {
  text-align: center;
  padding: 16px;
}

/* .camera-wrapper {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 20px;
  padding-bottom: 75%;
  border-radius: 16px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

video,
.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
/*
.camera-wrapper {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 20px;
  border-radius: 16px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

.camera-wrapper::before {
  content: "";
  display: block;
}

video,
.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
} */

.camera-wrapper {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: 0 auto 20px;
  border-radius: 16px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

/* Força o container a ter exatamente a mesma proporção do vídeo */
.camera-wrapper > video {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* O segredo: o wrapper vira flex e o vídeo define a altura */
.camera-wrapper {
  display: block;           /* ou flex se quiser centralizar */
  aspect-ratio: auto;       /* permite ser sobrescrito pelo JS */
}

/* Fallback para navegadores que não suportam aspect-ratio */
@supports not (aspect-ratio: 1) {
  .camera-wrapper::before {
    content: "";
    display: block;
    padding-top: 56.25%;
  }
}

button {
  padding: 16px 40px;
  background: #564AB1;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  min-width: 200px;
  width: 100%;
}

button:hover:not(:disabled) {
  background: #453a94;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.feedback {
  margin: 12px 0;
}
.status {
  margin: 8px 0;
  font-weight: 600;
  font-size: 15px;
}
.status.info { color: #007bff; }
.status.success { color: #28a745; }
.status.warning { color: #ffc107; }
.status.error { color: #dc3545; }

</style>
